import { render } from "./survey.vue?vue&type=template&id=179bf072&scoped=true"
import script from "./survey.vue?vue&type=script&lang=js"
export * from "./survey.vue?vue&type=script&lang=js"

import "./survey.vue?vue&type=style&index=0&id=179bf072&scoped=true&lang=css"
import "./survey.vue?vue&type=style&index=1&id=179bf072&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-179bf072"]])

export default __exports__